module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "title-chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781429938204_toc01#toctitle9",
      "id": "title9"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "subtitle-chapter"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The Liberal Westernizers")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("A")]), _vm._v("s used here, “Westernism” has nothing to do with the concept of “Occidentalism” forged in symmetrical opposition to Said’s “Orientalism” as a caricature of a certain Islamic perception of the West."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en106",
      "id": "ref_end_en106",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("1")])])]), _vm._v(" Nor is it my intention to stand the concept of Orientalism on its head in order to paint the Westernizers as unconditional admirers of the “West” and its governments. The term is, rather, patterned after nineteenth-century Russian “Westernism.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The Russian Westernizers, in opposition to the Slavophiles, urged adoption of the Enlightenment values that dominated western Europe together with the industrial civilization that, in their view, functioned properly only when accompanied by those values."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en107",
      "id": "ref_end_en107",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("2")])])]), _vm._v(" Russian Westernism did not imply uncritical admiration of western Europe but, rather, a set of values that might equally be described as “modernist” and could perfectly well accommodate a political critique of the West."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en108",
      "id": "ref_end_en108",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("3")])])]), _vm._v(" Thus, alongside liberal Westernism, there existed a Marxian Westernism and even a Europeanist Russian nationalism. The situation is no different in the Arab world.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Following Nadav Safran, I use the word “liberalism” here not in its nineteenth-century sense, designating a limitation of the role of the state, individualism, and “the sanctity of property,” but rather to mean “a general commitment to the ideal of remolding society on the basis of an essentially secular conception of the state and rational-humanitarian values.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en109",
      "id": "ref_end_en109",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("4")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Steeped in a democratic, humanist culture, the Westernizing liberals among the advocates of independence in the Arab world opposed National Socialism from the outset—a stand that by no means mitigated their anticolonialist hostility to Zionism. As those best qualified to criticize the premises of Zionism while defending the values of Western antifascist culture, the Westernizing liberals were a deep embarrassment to the Zionist movement. They did not, however, hold the greatest appeal\nfor the Arab masses, given the contradiction between those very values and the colonialist behavior of the Western powers posing as their champions—a problem still acutely relevant in the Arab world today.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The twofold denunciation of Nazism and Zionism made it possible for the Westernizers to contest the Zionists’ use of Nazi abominations as a way of legitimizing the Zionist enterprise. The liberals’ main argument was based on plain common sense: why should the Palestinians have to pay for the Nazis’ crimes? This objection stands as a constant in the long history of the Arab polemic against Zionism; the various ideological currents of the Arab world have all taken it up.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("My own father, Joseph Achcar, a pro-independence but also Francophile Lebanese, provided an early statement of this argument. It appeared in the dissertation he submitted in 1934 to the University of Lyons for a doctorate in law, in which he deplored Hitler’s assumption of power the previous year:\n")])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_vm._v("It goes without saying that we condemn, as the world’s conscience has done since then, the atavistic, savage conception that … professes to purify the German nation by eliminating elements foreign to it … .")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent-blocktext"
  }, [_c('span', [_vm._v("A government that springs from this reactionary, antiquated attitude readily ostracized the heterogeneous minorities among the people. The result was to drive away “the undesirables,” the Jews, who had to appeal to the hospitality of other countries. It was accorded to them only on precisely defined conditions, [given] the difficulty of finding them employment in the current period of economic crisis.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent-blocktext"
  }, [_c('span', [_vm._v("The Zionist leaders accordingly returned to the assault on the obstacles to creating a Jewish state in Palestine … .")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent-blocktext"
  }, [_c('span', [_vm._v("It is not possible to redress one injustice, if an injustice has been committed, by another, more serious and more costly injustice. That the Jewish people inhabited Palestine more than twenty centuries ago is beyond doubt. That it should aspire, after so long an interval, to take the country back and lay down the law there is sheer utopia."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en110",
      "id": "ref_end_en110",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("5")])])])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("This point of view was anything but exceptional. Indeed, there is every reason to wonder why liberal Westernist anticolonialism, the vehicle of\nthe Enlightenment in the Arab world, has attracted so much less attention than the most reactionary Arab currents, even those that were infinitely less influential.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Israel Gershoni, a specialist in Egyptian intellectual history at the University of Tel Aviv, has taken up the task of “deconstructing the hegemonic narrative” that maintains, contrary to all the documentary evidence, that a majority of Egyptians supported Nazism in the 1930s."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en111",
      "id": "ref_end_en111",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("6")])])]), _vm._v(" His research established that “the overwhelming majority of Egyptian voices—in the political arena, in intellectual circles, among the professional, educated, urban middle classes and even in the literate popular culture—rejected fascism and Nazism both as an ideology and a practice, and as ‘an enemy of the enemy.’”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en112",
      "id": "ref_end_en112",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("7")])])])])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_vm._v("The Egyptian public’s attitude toward fascism and Nazism was expressed principally through three types of representation. The first, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("imperialistic representation")]), _vm._v(", viewed fascism and Nazism as imperialist forces; the second, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("totalitarian representation")]), _vm._v(", perceived the Third Reich and the fascist regime in Italy as extreme forms of modern totalitarianism. And the third, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("racist representation")]), _vm._v(", scathingly denounced the ideology of Nazism and its racist theories and practices."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en113",
      "id": "ref_end_en113",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("8")])])])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Gershoni paid special attention to the Islamic variant of liberal Westernism in Egypt. In a study on Egyptian liberalism’s attitude toward Nazism from 1933 to the outbreak of the Second World War, he focuses on the weekly review "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Al-Ris"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_257.gif",
      "src": "e9781429938204_img_257.gif"
    }
  })]), _vm._v("la")]), _vm._v(", the first issue of which appeared in 1933."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en114",
      "id": "ref_end_en114",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("9")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Boasting a circulation that rose, late in the decade, to forty thousand copies, a third of which were sold in Arab capitals beyond Egypt’s borders, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("‘Al-Ris"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_257.gif",
      "src": "e9781429938204_img_257.gif"
    }
  })]), _vm._v("la")]), _vm._v(" provided a forum for some of the most prestigious Egyptian and non-Egyptian Arab intellectuals of the period: its contributors included Ali ‘Abdul-R"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_257.gif",
      "src": "e9781429938204_img_257.gif"
    }
  })]), _vm._v("ziq, Ahmad Am"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_299.gif",
      "src": "e9781429938204_img_299.gif"
    }
  })]), _vm._v("n, ‘Abb"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_257.gif",
      "src": "e9781429938204_img_257.gif"
    }
  })]), _vm._v("s Mahm"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_363.gif",
      "src": "e9781429938204_img_363.gif"
    }
  })]), _vm._v("d al-‘Aqq"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_257.gif",
      "src": "e9781429938204_img_257.gif"
    }
  })]), _vm._v("d, Muhammad Husayn Haykal, T"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_257.gif",
      "src": "e9781429938204_img_257.gif"
    }
  })]), _vm._v("ha Hussein, Tawf"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_299.gif",
      "src": "e9781429938204_img_299.gif"
    }
  })]), _vm._v("q al-Hak"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_299.gif",
      "src": "e9781429938204_img_299.gif"
    }
  })]), _vm._v("m,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en115",
      "id": "ref_end_en115",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("10")])])]), _vm._v(" Mahm"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_363.gif",
      "src": "e9781429938204_img_363.gif"
    }
  })]), _vm._v("d Taym"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_363.gif",
      "src": "e9781429938204_img_363.gif"
    }
  })]), _vm._v("r, and S"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_257.gif",
      "src": "e9781429938204_img_257.gif"
    }
  })]), _vm._v("ti‘al-Husri."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en116",
      "id": "ref_end_en116",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("11")])])]), _vm._v(" Together with a clear Arabist and Islamic orientation ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Al-Ris"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_257.gif",
      "src": "e9781429938204_img_257.gif"
    }
  })]), _vm._v("la")]), _vm._v(" means “the message”—an allusion to the Prophet Muhammad’s) along reformist lines,\n")])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_vm._v("it regularly devoted space to a methodical, highly critical review of internal developments in Nazi Germany and in fascist Italy, as\nwell as of the policies of Hitler and Mussolini in the international arena. It was not a solitary voice in doing so. Consistent support of liberal democracy and liberal values, attended by the rejection of fascist and Nazi totalitarianism, can also be found, for example, in the monthly "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Al-Hilal")]), _vm._v(", in the daily "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Al-Ahram")]), _vm._v(", and in the illustrated weekly "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Ruz al-Yusuf")]), _vm._v(" ["), _c('em', {
    staticClass: "i"
  }, [_vm._v("Rose al-Y"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_363.gif",
      "src": "e9781429938204_img_363.gif"
    }
  })]), _vm._v("suf")]), _vm._v("] throughout the entire decade."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en117",
      "id": "ref_end_en117",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("12")])])])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Gershoni shows that the critiques appearing in the review were comparable to the best analyses and refutations of Nazism published in Europe. The review denounced not only the racial exclusion organized by National Socialism, but also the “racist madness” of its scientific pretensions and their translation into medical practice. Avoiding the trap into which ultranationalists and religious conservatives fell, it struggled against all forms of the illusion that Nazi Germany was pro-Arab because it was anti-Jewish: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Al-Ris"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_257.gif",
      "src": "e9781429938204_img_257.gif"
    }
  })]), _vm._v("la")]), _vm._v(" denounced Nazism “as a ‘white imperialist attack’ on the Semitic peoples, first and foremost against the Arabs and Muslims,”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en118",
      "id": "ref_end_en118",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("13")])])]), _vm._v(" while assailing the specific form of anti-Judaism peculiar to Nazi anti-Semitism. Yet all this went hand in hand with fierce denunciation of the Zionist enterprise in Palestine."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en119",
      "id": "ref_end_en119",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("14")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Gershoni insists that "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Al-Ris"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_257.gif",
      "src": "e9781429938204_img_257.gif"
    }
  })]), _vm._v("la")]), _vm._v(" was in no sense marginal or exceptional: “It was actually the pro-fascist and pro-Nazi intellectual voices that were peripheral.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en120",
      "id": "ref_end_en120",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("15")])])]), _vm._v(" He offered further proof a few years later, in a study of another liberal Westernist publication, the Egyptian monthly "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Al-Hil"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_257.gif",
      "src": "e9781429938204_img_257.gif"
    }
  })]), _vm._v("l")]), _vm._v(" [The Crescent], which played a key role in shaping culture in the Middle East."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en121",
      "id": "ref_end_en121",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("16")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Like "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Al-Ris"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_257.gif",
      "src": "e9781429938204_img_257.gif"
    }
  })]), _vm._v("la")]), _vm._v(", "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Al-Hil"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_257.gif",
      "src": "e9781429938204_img_257.gif"
    }
  })]), _vm._v("l")]), _vm._v(" methodically denounced the totalitarian, imperialistic, and racist nature of Nazism and Italian Fascism. Gershoni dwells in particular on two essays that appeared in July and August 1933, one about the great mass slaughters of history, the other about anti-Semitism; "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Al-Hil"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_257.gif",
      "src": "e9781429938204_img_257.gif"
    }
  })]), _vm._v("l")]), _vm._v(" warned that the Jews might fall victim to a massacre on a scale with the one that had decimated the Armenians, which it cited as the most terrible in modern history."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en122",
      "id": "ref_end_en122",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("17")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Gershoni thus corroborates what his colleague at the University of Tel Aviv, Ami Ayalon (not to be confused with the Ami Ayalon who has moved from the head of Shin Beth, the Israeli internal security service, to the highest levels of the Labor Party), noted in an earlier essay on Egyptian intellectuals in the 1930s:\n\n")])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_vm._v("The voices of democracy’s champions were louder than those of its critics who were fascinated by the Führer and the Duce. They grew still louder toward the end of the decade. Egyptian thinkers and writers may have undergone a crisis of orientation during that period regarding issues of communal and individual identity in the extreme complexities of modernity. Most of them, so it seems, nevertheless remained dedicated to the democratic idea, with its implied liberties and rights, and were prepared to defend it at all times against the perils of totalitarianism."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en123",
      "id": "ref_end_en123",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("18")])])])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Today this stance is generally effaced by anti-Arab propaganda that depicts “the Arabs” as Nazis deep down, dovetailing with its complement in the Arab world, which does its utmost to convey the same impression because it corresponds to its own vision of things. Yet the Zionists themselves were capable of making the distinction in the 1930s. Philip Khoury, relying on documents discovered in the Central Zionist Archives (CZA) in Jerusalem, describes a 1936 meeting in Syria between Eliahu Epstein, the representative of the Jewish Agency for Palestine, and Fakhri al-B"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_257.gif",
      "src": "e9781429938204_img_257.gif"
    }
  })]), _vm._v("r"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_363.gif",
      "src": "e9781429938204_img_363.gif"
    }
  })]), _vm._v("di, one of the main leaders of the National Bloc, the leading Syrian organization of pro-independence liberal Westernizers, and a later meeting with other Bloc leaders, including Shukri al-Quwwatli, a radical nationalist, who would in time twice serve as president of independent Syria."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en124",
      "id": "ref_end_en124",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("19")])])]), _vm._v(" Epstein was exploring the possibility of an agreement with the advocates of Syrian independence; B"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_257.gif",
      "src": "e9781429938204_img_257.gif"
    }
  })]), _vm._v("r"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_363.gif",
      "src": "e9781429938204_img_363.gif"
    }
  })]), _vm._v("di laid out preconditions, underscoring his party’s moderating role:\n")])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_vm._v("Thousands of people wanted to go from Syria to Palestine to help their brethren but we prevented them from doing so … . We also defended Syrian Jews from attacks by the press and the street mob … . The slogans which are raised now and around which the struggle takes place are, “an end to immigration.” And the Arab leaders cannot stop the clashes unless some gain is made in regard to stopping immigration."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en125",
      "id": "ref_end_en125",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("20")])])])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("B"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_257.gif",
      "src": "e9781429938204_img_257.gif"
    }
  })]), _vm._v("r"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_363.gif",
      "src": "e9781429938204_img_363.gif"
    }
  })]), _vm._v("di was not talking through his hat. The Syrian independence advocates had indeed defended the Jews of Syria and had taken active measures on their behalf. Witness a Palestinian English-language daily’s February 1935 report on the reaction of the main Syrian pro-independence\ndaily, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Alif B"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_257.gif",
      "src": "e9781429938204_img_257.gif"
    }
  })])]), _vm._v("’, to the bloody anti-Jewish riots in Constantine"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_ftn01#ftn_fn7",
      "id": "ref_ftn_fn7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "footnote_number"
  }, [_vm._v("g")])])])]), _vm._v(" the preceding August:\n")])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_vm._v("Condemnation of the Moslems of Algiers [Algeria] for provoking anti-Jewish riots and of the German government in driving Jews from Germany without reason, is contained in a leading article published in “Alif Ba,” the Moslem daily of Damascus, in its issue of February 12. “The Jewish religion is one of the most honored in the world, and it is the duty of members of all other religions to treat it with esteem,” says the article. “It is true that we are fighting Zionism, but we are not fighting the Jews as such. Judaism is not necessarily Zionism.” Arabs should strongly oppose anti-Semitism, the paper urges, and refuse to help those who advocate it as the North African Moslems are doing. That is a sin which can never be atoned."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en127",
      "id": "ref_end_en127",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("22")])])])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Quwwatli explained that an agreement depended on whether the Zionists intended to “make of Palestine a Jewish National Home or to make a Jewish National Home in Palestine. If the former, then we are categorically opposed to it and there is no way to come to an understanding. But if it means the latter then we are ready … to find a solution to the mutual advantage of both parties.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en128",
      "id": "ref_end_en128",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("23")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("This attitude was widespread among liberal Arab nationalists. The Egyptian ‘Abdul-Rahm"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_257.gif",
      "src": "e9781429938204_img_257.gif"
    }
  })]), _vm._v("n ‘Azz"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_257.gif",
      "src": "e9781429938204_img_257.gif"
    }
  })]), _vm._v("m, who would become the first secretary of the League of Arab States at its creation in 1945, said in a November 1935 speech delivered in Palestine itself, in the city of Nablus, on the eighteenth anniversary of the Balfour Declaration:\n")])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_vm._v("What is the Balfour Declaration worth? It is a commitment on the part of those who do not own to give what is not theirs. It aims to fool the Jews into clinging to hopes whose objective is collision with the East and capitulation to the West. The result\ncan only be a state of eternal hostility with the Arab peoples and the nations of Islam … . The Balfour Declaration is detrimental for the Jews as well as the Arabs … .")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent-blocktext"
  }, [_c('span', [_vm._v("The West will not deal justly with the Jews for as long as it continues to be the West that we know and that the Jews know. Do the Zionists wish to inherit Palestine and, along with it, the unending hostility of the East? I think that the Jews will avoid that. Who knows? Perhaps we will one day be able to celebrate the burial of the Balfour Declaration together with them, after all of us have come to see that this Declaration is a harbinger of evil for Arabs and Jews alike."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en129",
      "id": "ref_end_en129",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("24")])])])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Consider also the first gathering of Arab feminists, held in Cairo from October 15 to 18, 1938, in solidarity with Palestine. It was convened three months after the July 1938 international conference in Evian, France, mentioned in the introduction, which the pioneer of Egyptian and Arab feminism, Huda Shaarawi (Sha‘r"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_257.gif",
      "src": "e9781429938204_img_257.gif"
    }
  })]), _vm._v("wi), attacked in her opening address: “Not a single representative of one of the participating states, not even the representative of Great Britain or the United States, has dared declare that his government was prepared to provide a haven to these rejected, shelterless people, while Palestine, to which they have no familial or national ties, has taken in four hundred thousand of them down to the present day.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en130",
      "id": "ref_end_en130",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("25")])])]), _vm._v(" The Palestinian Arab nationalist Akram Zu‘aytir, who provides a report on her speech, adds: “She called on Jewish compatriots to show solidarity with us in order to bring the Zionists to renounce their mad dreams.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en131",
      "id": "ref_end_en131",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("26")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("How did the Arab liberal Westernizers in Palestine itself position themselves? A good example is George Antonius, who, after a stint as an official in the British colonial administration in Palestine, became one of the political and intellectual leaders of the Arab nationalist movement in general and the liberal current in particular. A member of the Palestinian and Arab delegations, he was the main Palestinian Arab spokesperson at the important London Conference of 1939. The year before, in "), _c('em', {
    staticClass: "i"
  }, [_vm._v("The Arab Awakening")]), _vm._v("—a book that Said rightly calls “"), _c('em', {
    staticClass: "i"
  }, [_vm._v("the")]), _vm._v(" classic and foundational book on Arab nationalism”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en132",
      "id": "ref_end_en132",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("27")])])]), _vm._v("—Antonius wrote, remarkably:\n")])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_vm._v("There seems to be no valid reason why Palestine should not be constituted into an independent Arab state in which as many\nJews as the country can hold without prejudice to its political and economic freedom would live in peace, security and dignity, and enjoy full rights of citizenship … .")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent-blocktext"
  }, [_c('span', [_vm._v("The relief of Jewish distress caused by European persecution must be sought elsewhere than in Palestine, for the country is too small to hold a larger increase of population, and it has already borne more than its fair share … .")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent-blocktext"
  }, [_c('span', [_vm._v("The treatment meted out to Jews in Germany and other European countries is a disgrace to its authors and to modern civilisation; but posterity will not exonerate any country that fails to bear its proper share of the sacrifices needed to alleviate Jewish suffering and distress. To place the brunt of the burden upon Arab Palestine is a miserable evasion of the duty that lies upon the whole of the civilised world. It is also morally outrageous. No code of morals can justify the persecution of one people in an attempt to relieve the persecution of another. The cure of the eviction of the Jews from Germany is not to be sought in the eviction of the Arabs from their homeland; and the relief of Jewish distress may not be accomplished at the cost of inflicting a corresponding distress upon an innocent and peaceful population."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en133",
      "id": "ref_end_en133",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("28")])])])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Antonius was by no means an isolated voice, as René Wildangel (now an adviser to the Green fraction in the German Bundestag) has shown in a book that, like Gershoni’s, seeks to deconstruct the dominant narrative. "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en134",
      "id": "ref_end_en134",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("29")])])]), _vm._v(" Wildangel’s thorough examination of the 1930s and 1940s Palestinian Arab press, in all its diversity, marshals a wealth of quotations from articles, as well as reproductions of cartoons, that provide solid support for his conclusion that\n")])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_vm._v("voices critical of National Socialism were not at all rare in Palestinian Arab newspapers of the 1930s … . Whatever the motivation for such criticism—whether it was moral and humanistic (denouncing the brutality of the German dictatorship), political and ideological (taking issue with the idea of fascism), religious (critical of the Nazis’ policy toward the churches) or, rather, pragmatically inspired by the situation in Palestine (pointing, for example, to the consequences of Jewish immigration)—the range of such diverse motivations is impressive, and gives the lie\nto one-sided judgments of the position taken by the Arab Palestinians. "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en135",
      "id": "ref_end_en135",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("30")])])])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("With the exacerbation of tensions, especially from 1936 on, the radical wing of the national movement led by the mufti of Jerusalem, Hajj Amin al-Husseini, came to represent the Arab majority view in Palestine. However, the pro-independence current opposed to the mufti remained very influential and had major media at its disposal, including a broad array of publications, notably the daily "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Filast"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_299.gif",
      "src": "e9781429938204_img_299.gif"
    }
  })]), _vm._v("n")]), _vm._v(" and the weekly "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Al-Akhb"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_257.gif",
      "src": "e9781429938204_img_257.gif"
    }
  })]), _vm._v("r")]), _vm._v(", which frequently aired virulent anti-Nazi criticisms.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Filast"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_299.gif",
      "src": "e9781429938204_img_299.gif"
    }
  })]), _vm._v("n")]), _vm._v(" ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Palestine")]), _vm._v(", transliterated “"), _c('em', {
    staticClass: "i"
  }, [_vm._v("Falastin")]), _vm._v(",” the most common colloquial pronunciation, immediately under the paper’s Arabic name) was one of the oldest and most important. Rashid Khalidi characterizes it as “Palestine’s main Arabic-language daily” during the period “and probably the country’s fiercest and most consistent critic of the Zionist enterprise.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en136",
      "id": "ref_end_en136",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("31")])])])])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_vm._v("As time went on, moreover, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Filastin")]), _vm._v(" came to be relied upon throughout the Arab world for news of Zionist policy initiatives and the progress of Zionist colonization in Palestine, thereby playing an important role in establishing Zionism as an issue that concerned all Arabs. Even before World War I, the paper’s editorials and articles on Zionism were picked up and reproduced by other newspapers, not only in Palestine but in Beirut, Cairo, Damascus, and other centers throughout the Arabic-speaking world."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en137",
      "id": "ref_end_en137",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("32")])])])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("‘Abd-ul-Rahm"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_257.gif",
      "src": "e9781429938204_img_257.gif"
    }
  })]), _vm._v("n ‘Abdul-Ghani, in his 1995 examination of the Palestinian press between 1933 and 1939, deplores, somewhat unfairly, the general poverty of its treatment of Nazism. The more systematic investigation of the same publications that René Wildangel carried out twelve years later led Wildangel to underscore the richness of the information they transmitted. ‘Abdul-Ghani’s quotations from "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Filast"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_299.gif",
      "src": "e9781429938204_img_299.gif"
    }
  })]), _vm._v("n")]), _vm._v(" are, nevertheless, instructive, showing that from 1933 on it depicted Nazism as reactionary and dictatorial while voicing the conviction that democracy would eventually triumph."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en138",
      "id": "ref_end_en138",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("33")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The newspaper’s opposition to Nazism also flowed from an acute awareness, which can only be termed premonitory, that Hitler’s accession to power would reinforce the Zionist enterprise. Hence the ironic\nApril 1933 editorial Wildangel describes, which declares “that the Zionist association in Palestine had decided to include, in a gallery of personalities who had made significant contributions to the construction of the country, such as ‘Herzl, Nordau, Balfour, Lloyd George and others … a portrait of Hitler as well.’”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en139",
      "id": "ref_end_en139",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("34")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("In an article that appeared on June 17, 1934, under the title “Nazi Palestine!!!” "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Filast"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_299.gif",
      "src": "e9781429938204_img_299.gif"
    }
  })]), _vm._v("n")]), _vm._v(" reacted vigorously to Zionist accusations of Arab pro-Nazism:\n")])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_vm._v("Palestine needs neither fascism nor Nazism in order to arouse the feelings of her sons against Zionism and its designs in the Arab world. This repulsion already exists; it had already taken root in people’s minds several years ago, well before Nazism … . What authorizes the Jews to announce sorrowfully to the Arabs that a Nazi movement has sprung up among them? Is it the Arabs who have driven the Jews from their land, or is it rather the Jews who are driving Arabs from their homes and persecuting them to the point of depriving them of human beings’ most basic right, the right to life?"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en140",
      "id": "ref_end_en140",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("35")])])])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("According to Orayb Aref Najjar, who has studied the editorials published in "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Filast"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_299.gif",
      "src": "e9781429938204_img_299.gif"
    }
  })]), _vm._v("n")]), _vm._v(" during the Second World War,\n")])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_vm._v("the newspaper supported the pro-Allied argument in two ways. First, it made distinctions between the universal and local, creating a hierarchy of values that explained why the paper sided with the Allies. Second, by drawing upon traditional Arab-Islamic values (and by mining the historical record for examples), the editors suggested that Islamic values precluded fighting with Nazi Germany and urged “tolerance in trying times” to deal with continued colonial rule Palestinians found cruel and unacceptable. "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en141",
      "id": "ref_end_en141",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("36")])])])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Even as "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Filast"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_299.gif",
      "src": "e9781429938204_img_299.gif"
    }
  })]), _vm._v("n")]), _vm._v(" vigorously attacked the Axis powers, and, especially, Nazism, it mobilized the classic argument on the issue of Jewish immigration. Why should the blameless Palestinians be made to pay for the appalling European persecution of the Jews? Why did the United States, Britain, and Britain’s overseas allies not open their doors to Jewish\nimmigration? The daily pursued a campaign for Palestinian rights, calling for the liberation of Palestinian political prisoners and the return of exiled Palestinian leaders—most of whom numbered among its political adversaries.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("All things considered, the attitude of the Palestinian liberals was one of the most remarkable and commendable forms of opposition to Nazism in the world. Not only did they refuse to side with “the enemy of their enemy,” or, more precisely, “the enemy of their two enemies” (as did a large segment of the nationalist elites under the lead of the mufti of Jerusalem), or even to take refuge in a prudent semineutrality (as did a number of Arab governments that were officially allied with London or controlled by it); they went so far as to support the oppressor of their own nation in its war against the sworn enemy of those who were trying to conquer their land. They did so, Najjar emphasizes, in the name of an ethical hierarchy that put liberal values, both secular and religious, above every other consideration, in the hope (or, perhaps, wish) that those values would lead the nations fighting for them to render the Palestinians justice. In this regard, Najjar cites a "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Filast"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_299.gif",
      "src": "e9781429938204_img_299.gif"
    }
  })]), _vm._v("n")]), _vm._v(" editorial of September 9, 1939—that is, a mere week after the outbreak of the Second World War (and four days after the United States had proclaimed its neutrality): “War has placed us in a new situation with regard to our relations with Britain. We are connected to it today in a matter that is more universal than our private cause. We are not calling on Arabs to sacrifice their cause, but we are asserting that the present conflict between the democratic forces and dictatorial forces has dictated that we take sides with one or the other.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en142",
      "id": "ref_end_en142",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("37")])])]), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_ftn01#ftn_fn8",
      "id": "ref_ftn_fn8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "footnote_number"
  }, [_vm._v("h")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("All this is very remote from the currently prevailing image of a Palestinian people that supposedly responded to Mufti Amin al-Husseini’s exhortations by chanting hallelujah in unison. The shroud of silence cast over the real positions of a major segment of the Palestinian elite is explained by political motives that have not varied since the 1939 London negotiations, when Zionist leaders admitted they preferred dealing with the underlings of the much maligned Amin al-Husseini. “It will be much easier for us to counter their claims,” Ben-Gurion explained. “We\ncan say that they stand for terrorism and represent only a small part of the Arab population. A broad delegation including ‘moderates’ will display the Arab public’s general resistance to the Jews.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en144",
      "id": "ref_end_en144",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("39")])])]), _vm._v(" Propaganda literature has always projected the mufti’s stance onto all the Arabs of Palestine, with a view to portraying them as ardent partisans of the Axis powers. The Zionist intelligence services’ internal communications were more circumspect:\n")])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_vm._v("The Arab position on the war was the subject of much speculation. The Jewish Agency’s sources stressed the Arab inclination to support the Nazis for mostly obvious political reasons but also, at times, out of ideological identification. The Zionist intelligence services reported a few German secret agents working among Palestine’s Arabs but assumed that no single organization could really be considered a fifth column. By one estimate [dated December 7, 1941], some 60 percent of the country’s Arabs supported the Nazis."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en145",
      "id": "ref_end_en145",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("40")])])])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("It is, in fact, remarkable that "), _c('em', {
    staticClass: "i"
  }, [_vm._v("no more than")]), _vm._v(" 60 percent of Palestinian Arabs supported the Nazis at that point, when Germany was at the height of its military success. Only later would reversals on the Soviet front and the United States’ entry into the war put a new face on matters. (No more than 60 percent, let us add, according to a source predisposed, for a host of reasons, to overestimate the number of pro-Nazi Palestinians.)")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The official position put forward by the founders of the League of Arab States on the Palestinian question in 1944 has also been relegated to the shadows. It was due to the dominant role played by the liberal Westernizing current—thanks to the leading position of Cairo’s Wafdist government—in the league’s foundation. Indeed, Egypt’s Wafd was the party that best represented liberal Westernism within the Arab independence movement throughout the first half of the century; it enjoyed the support of its cothinkers in the governments of both Beirut and Damascus.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("At the October 7, 1944, meeting in Alexandria, delegations led by the heads of the Egyptian, Iraqi, Jordanian, and Lebanese governments adopted a protocol that was the prelude to the creation of the League of Arab States. The special resolution on Palestine contained in the Alexandria Protocol declares that the committee\n\n")])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_vm._v("is second to none in regretting the woes which have been inflicted upon the Jews of Europe by European dictatorial states. But the question of these Jews should not be confused with Zionism, for there can be no greater injustice and aggression than solving the problem of the Jews of Europe by another injustice, i.e., by inflicting injustice on the Arabs of Palestine of various religions and denominations."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en146",
      "id": "ref_end_en146",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("41")])])])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The April 1946 report of the Anglo-American Committee of Inquiry contains exactly the same discourse:\n")])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_vm._v("Arab spokesmen profess the greatest sympathy for the persecuted Jews of Europe, but they point out that they have not been responsible for this persecution and that it is not just that they should be compelled to atone for the sins of the Western peoples by accepting into their country hundreds of thousands of victims of European anti-Semitism. Some Arabs even declare that they might be willing to do their share in providing for refugees on a quota basis if the United States, the British Commonwealth and other Western countries would do the same."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en147",
      "id": "ref_end_en147",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("42")])])]), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_ftn01#ftn_fn9",
      "id": "ref_ftn_fn9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "footnote_number"
  }, [_vm._v("i")])])])])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The official position of the Arab states explicitly ruled out expulsion of Jews who had already settled in Palestine. Witness a speech delivered by the first secretary-general of the League of Arab States, the Wafdist Egyptian ‘Abdul-Rahm"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_257.gif",
      "src": "e9781429938204_img_257.gif"
    }
  })]), _vm._v("n ‘Azz"), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429938204_img_257.gif",
      "src": "e9781429938204_img_257.gif"
    }
  })]), _vm._v("m, six months after the end of World War II, at a moment when Arabs had reason to think that they would enjoy military superiority in an armed conflict with Zionists. The continuity with his previously cited speech of 1935 is striking.")])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_vm._v("You will no doubt remember that the Arab league has in the last six months collided with the Jews. It was a violent collision with a weak and dispersed people who, of all peoples, most need our sympathy, for they are our persecuted cousins … . The Zionists\nare a curse on the Jews themselves and, indeed, on us Arabs. We still extend to the Jews the hand of friendship, and we do not want to share in the crime of persecuting them … . I say, confident in God and guided by the witness of current events, that in this matter we will win a victory which will not disperse the Jews as the Europeans dispersed them, for this is not in our nature nor in the nature of our fathers before us. They will realize … that we are their brothers, with whom they can live as our Christian brothers have done, and that they can reach in the common homeland of the Arabs the highest functions and positions."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en149",
      "id": "ref_end_en149",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("44")])])])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The proposals for a resolution of the Palestine conflict put forward by the Arab states in 1946–47 were entirely in keeping with this approach. They were laid out in the report presented by the United Nations Special Committee on Palestine (UNSCOP) to the General Assembly in September 1947 as a preliminary to the debate and vote on the partition plan recommended in the same report:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "al"
  }, [_c('div', {
    staticClass: "asl"
  }, [_c('b', [_vm._v("a.")]), _vm._v(" That Palestine should be a unitary State, with a democratic constitution and an elected legislative assembly,")]), _vm._v(" "), _c('div', {
    staticClass: "asl"
  }, [_c('b', [_vm._v("b.")]), _vm._v(" That the constitution should provide, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("inter alia")]), _vm._v(", guarantees for (i) the sanctity of the Holy Places and, subject to suitable safeguards, freedom of religious practice in accordance with "), _c('em', {
    staticClass: "i"
  }, [_vm._v("the status quo")]), _vm._v("; (ii) full civil rights for all Palestine citizens, the naturalization requirement being ten years’ continuous residence in the country; (iii) protection of religious and cultural rights of the Jewish community, such safeguards to be altered only with the consent of the majority of the Jewish members in the legislative assembly,")]), _vm._v(" "), _c('div', {
    staticClass: "asl"
  }, [_c('b', [_vm._v("c.")]), _vm._v(" That the constitution should provide also for (i) adequate representation in the legislative assembly of all important communities, provided that the Jews would in no case exceed one-third of the total number of members [that is, the proportion of Jews in the Palestinian population in 1947]; (ii) the strict prohibition of Jewish immigration and the continuation of the existing restrictions on land transfer, any change in these matters requiring the consent of a majority of the Arab members of the legislative assembly; (iii) the establishment of a Supreme Court which\nwould be empowered to determine whether any legislation was inconsistent with the constitution."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en150",
      "id": "ref_end_en150",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("45")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("As the Arab states thus came out in favor of integrating the Jews living in Palestine in what would have effectively been a binational state, they also made a proposal about the Jewish refugees then in Europe. That same year, 1947, the UN ambassadors of the Arab countries that were then members of the international organization—Egypt, Iraq, Lebanon, the Saudi Arabian Kingdom, Syria, and Yemen—joined those from Afghanistan, Colombia, and Pakistan on a subcommittee that opposed the partition of Palestine and submitted a draft resolution to the General Assembly on the problem of resettling “Jewish refugees and displaced persons” from Europe.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The gist of the resolution, put to the General Assembly for a vote, was that the task of finding a home for the refugees should be equitably shared. The subcommittee pointed out that 287,000 Jewish immigrants had been admitted to Palestine between 1933 and 1946, compared with 188,000 to the United States, 65,000 to the United Kingdom, and some 110,000 to a number of other countries, including Canada, Australia, South Africa, and certain countries of Latin America. In other words, Palestine had “absorbed a disproportionately large number of Jewish immigrants and [could] not take any more without serious injury to the economy of the country and the rights and position of the indigenous population.” As for the problem of the refugees still waiting in camps, the subcommittee offered the following recommendations:\n")])]), _vm._v(" "), _c('div', [_c('div', [_vm._v("(i) That countries of origin should be requested to take back the Jewish refugees and displaced persons belonging to them, and to render them all possible assistance to resettle in life;")]), _vm._v(" "), _c('div', [_vm._v("(ii) That those Jewish refugees and displaced persons who cannot be repatriated should be absorbed in the territories of Members of the United Nations in proportion to their area, economic resources, per capita income, population and other relevant factors;")]), _vm._v(" "), _c('div', [_vm._v("(iii) That a Special Committee of the General Assembly should be set up to recommend for acceptance of the Members of the United Nations a scheme of quotas of Jewish refugees and displaced persons to be resettled in their respective territories,\nand that the Special Committee should, as far as possible, work in consultation with the International Refugee Organization or its Preparatory Commission."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en151",
      "id": "ref_end_en151",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("46")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Submitted to the General Assembly on November 24, 1947, the draft resolution received sixteen votes in favor—including those of the nine subcommittee members—and sixteen opposed, with twenty-six abstentions. It was, consequently, not adopted. A remark that Walid Khalidi made twenty-four years later reflects the bitterness that well-informed individuals in the Arab world must have felt at the time: “Jewish immigration to Palestine, even if it means flooding the Arabs out—by all means; but a modest contribution by each Western country to reflect the ostensibly humanitarian concern for Jewish refugees—nothing doing. Such are the ways of Charity.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_bm02#end_en152",
      "id": "ref_end_en152",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("47")])])]), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429938204_ftn01#ftn_fn10",
      "id": "ref_ftn_fn10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "footnote_number"
  }, [_vm._v("j")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The most common Arab attitude to the Holocaust would continue to be grounded in the conviction that people entirely innocent of the crime had been forced to pay for it, and that the governments that professed to be the most deeply shaken by it were hypocrites seeking, above all, to shirk their duties, neglecting the obligations dictated both by their own responsibility for the Jewish genocide—or their failure to save the Jews—and by humanitarian considerations. A sense of profound injustice and Western hypocrisy has continued to rankle Arab public opinion to the present day.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e4cbe7a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429938204_c02.vue
// module id = 81
// module chunks = 0